import { selectPortalCustomizationsCustomization } from '@/redux/customizations/reducers';
import { useAppSelector } from '@/redux/hooks';

export default function useCompanyCustomizations() {
  return useAppSelector((state) => selectPortalCustomizationsCustomization(state));
}
